import { useFormContext } from 'react-hook-form';
import { suggestTemplateNames } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';
interface SubmissionTemplateInputProps {
  name: string;
  label?: string;
  placeholder?: string;
  focused?: boolean;
  showMandatorySymbol?: boolean;
}

const SubmissionFormTemplateAutoComplete = ({
  name,
  label = 'Submission Form Template',
  placeholder = 'select submission form template',
  focused = false,
  showMandatorySymbol = false,
}: SubmissionTemplateInputProps) => {
  const { setValue } = useFormContext();

  const onTemplateSearch = async (searchText: string) => {
    const response = await suggestTemplateNames(searchText.trim());
    return response?.data?.map((item) => item?.templateName || '') ?? [];
  };

  const onChange = (data) => setValue(name, data);
  return (
    <WsAutocompleteInput
      key={name}
      getOptions={onTemplateSearch}
      onChange={onChange}
      label={label}
      options={[]}
      placeholder={placeholder}
      showMandatorySymbol={showMandatorySymbol}
      multiple={false}
      freeSolo={false}
      name={name}
      size="small"
      focused={focused}
      requireSelection={false}
    />
  );
};

export default SubmissionFormTemplateAutoComplete;
